export default "__VITE_ASSET__DNl4pYtw__"